/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDollar: {
  name: 'dollar';
  data: string;
} = {
  name: 'dollar',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1a1 1 0 0 1 1 1v1.071c2.692.384 5 2.293 5 4.929a1 1 0 1 1-2 0c0-1.248-1.149-2.555-3-2.908v5.98c2.692.383 5 2.292 5 4.928s-2.308 4.545-5 4.929V22a1 1 0 1 1-2 0v-1.071C8.308 20.545 6 18.636 6 16a1 1 0 1 1 2 0c0 1.248 1.149 2.555 3 2.908v-5.98C8.308 12.546 6 10.637 6 8s2.308-4.545 5-4.929V2a1 1 0 0 1 1-1Zm1 17.908c1.851-.353 3-1.66 3-2.908s-1.149-2.555-3-2.908v5.816ZM8 8c0-1.248 1.149-2.555 3-2.908v5.816C9.149 10.555 8 9.248 8 8Z" fill="currentColor"/></svg>`,
};
